export function truncate(input: string, maxLengh: number) {
  if (input.length > maxLengh) {
    return input.substring(0, maxLengh) + '...'
  }
  return input
}


// localeCompare builds a fresh collator on every call, so sorting a community
// of a few thousand members built one per comparison. One shared instance with
// the same locale and options compares identically - that is what
// localeCompare does internally - and is built once.
export const nameCollator = new Intl.Collator('he', { sensitivity: 'base' })
